import { action } from '@ember/object';
import SettingsRolesBaseController from '../base';
import RoleModel from 'scaleflow/models/role';

export default class SettingsRolesListCreateController extends SettingsRolesBaseController {
  declare model: RoleModel;

  @action
  cancel() {
    // Delete the record instead of just rolling back
    void (this.model as any).destroyRecord();
    this.goToListPage();
  }
}
